export const SESSION_HISTORY = 'session_history';
export const KASEYA_ONE_TOKEN = 'kaseyaone_token';